var button = {
    additionalInfo: 'ADD DOCUMENTS OR COMMENTS',
    back: 'back',
    cancel: 'Cancel',
    cancelDispute: 'CANCEL DISPUTE',
    cancelQuestionnaire: 'Yes, Cancel Dispute',
    cancelThisDispute: 'CANCEL THIS DISPUTE',
    close: 'close',
    delete: 'Yes, Delete',
    done: 'done',
    dontCancel: 'No, Do Not Cancel',
    getStarted: "Let's Get Started",
    goBack: 'Back',
    loadMore: 'LOAD MORE',
    neverMind: 'NEVER MIND',
    next: 'Next',
    nextQuestion: 'Next Question',
    noDelete: "No, Don't Delete",
    noDontDisputeIt: "No, Don't Dispute It",
    noExit: "No, Don't Exit",
    noGoBack: 'NO, GO BACK',
    ok: 'ok',
    previousQuestion: 'Previous Step',
    redispute: 'YES, REDISPUTE TRANSACTION',
    secureMessaging: 'GO TO SECURE MESSAGING',
    submit: 'Submit',
    submitDispute: 'Submit Dispute',
    tryAgain: 'Try Again',
    uploadDocuments: 'UPLOAD DOCUMENT',
    yesClose: 'Yes, Close',
    yesContinueDispute: 'Yes, Continue to Dispute',
    yesExit: 'Yes, Exit'
};
export default button;
//# sourceMappingURL=button.js.map